//@ts-check

/**
 * @type {import("./types").getDotPropType}
 */
export default (function (obj, propPath) {
  var seg = obj;
  propPath.split('.').map(function (key) {
    return seg = seg[key];
  });
  return seg;
});